define('form/jquery.multiply',['jquery'], function($) {
	/**
	 * After select multiply element
	 */
    $.fn.multiply = function( type ) {  
		this.focus(function (e) {
			var rtarget = $(this).closest(".multiply");
			if (rtarget.length == 0) rtarget = $(this);
			else if (!rtarget.hasClass("data")) {
				var n = rtarget.clone(true);
				rtarget.after(n);
				rtarget.addClass("data");
			}
		});

		this.blur(function (e) {
			var rtarget = $(this).closest(".multiply");
			if (rtarget.length == 0) rtarget = $(this);
			if ($(this).val()=='') {
				rtarget.remove();
			}
		});
	};
});
